<template>
  
  <div id="app">
    <b-container fluid>
    <!-- <div class="container-fluid"> -->
      <Menu /> <!-- se añade el menú -->
      <b-breadcrumb :items="items"></b-breadcrumb>
      <router-view/>
      <Footer />
   <!--  </div> -->
    </b-container>
  </div>

</template>

<script>
import Menu from './components/Menu'
import Footer from './components/Footer'

export default {
  name: 'App',
  components: {
    Menu,
    Footer
  },
  data() {
      return {
        items: [
          {
            text: 'Home',
            href: '/home',
            to:"/home"
          },
          {
            text: 'Página actual',
            active: true
          }
        ]
      }
    }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #fbedee; 
}

/*
.navbar-nav a {
  color: #4d502c;
}
*/

#nav {
  padding: 30px;
}

/*
#nav a {
  font-weight: bold;
  color: #2c3e50;
}
*/


.breadcrumb-item a {
    color: rgb(43, 0, 255);
}


#app a {
    color: rgb(43, 0, 255);
    text-decoration: underline;  
  }

.btn {
    color: white !important;
    }

</style>
